import * as yup from "yup";

export const alterarPerfilUsuarioSchema =  yup.object().shape({
  perfil: yup.string().required("O perfil é obrigatório"),
});
  